import { render, staticRenderFns } from "./card-ticket-module.vue?vue&type=template&id=67553882&scoped=true&"
import script from "./card-ticket-module.vue?vue&type=script&lang=js&"
export * from "./card-ticket-module.vue?vue&type=script&lang=js&"
import style0 from "./card-ticket-module.vue?vue&type=style&index=0&id=67553882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67553882",
  null
  
)

export default component.exports